export default __webpack_public_path__ + "static/about_nre-157b5521b276a2f3aad7f8693536675e.webp";